export default __webpack_public_path__ + "static/media/brainstorming.e15fc157.mp4";